/* ==========================================================================
   WESTERN — theme behaviour
   Plain browser JavaScript, no framework and no build step.
   ========================================================================== */

(function () {
  "use strict";

  // Formats cents using the shop's own money format string, which
  // layout/theme.liquid puts on window as themeMoneyFormat.
  function money(cents) {
    var format = window.themeMoneyFormat || "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    var whole = amount.split(".")[0];
    var fraction = amount.split(".")[1];
    var grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case "amount":
          return grouped + "." + fraction;
        case "amount_no_decimals":
          return grouped;
        case "amount_with_comma_separator":
          return grouped.replace(/,/g, ".") + "," + fraction;
        case "amount_no_decimals_with_comma_separator":
          return grouped.replace(/,/g, ".");
        case "amount_with_apostrophe_separator":
          return grouped.replace(/,/g, "'") + "." + fraction;
        default:
          return grouped + "." + fraction;
      }
    });
  }

  /* ---------------------------------------------------------------- drawers */

  function closeAllDrawers() {
    document.querySelectorAll(".drawer.is-open, .overlay.is-open").forEach(function (el) {
      el.classList.remove("is-open");
    });
    document.body.style.overflow = "";
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    closeAllDrawers();
    drawer.classList.add("is-open");
    var overlay = document.querySelector('.overlay[data-for="' + id + '"]');
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-drawer-open]");
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
      return;
    }

    if (event.target.closest("[data-drawer-close]") || event.target.closest(".overlay")) {
      closeAllDrawers();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeAllDrawers();
  });

  /* ------------------------------------------------- hero → chrome handover */

  // While the hero fills the screen the sidebar and compact bar stay hidden;
  // they fade in once the visitor has scrolled most of a viewport height.
  var hero = document.querySelector("[data-hero]");

  if (hero) {
    var syncChrome = function () {
      var past = window.scrollY > window.innerHeight * 0.7;
      document.body.classList.toggle("chrome-hidden", !past);
    };
    syncChrome();
    window.addEventListener("scroll", syncChrome, { passive: true });
    window.addEventListener("resize", syncChrome);
  } else {
    // No hero on this page — make sure the chrome is never left hidden,
    // including when a merchant removes the hero section from the home page.
    document.body.classList.remove("chrome-hidden");
  }

  /* ----------------------------------------------------------- filter panel */

  var filterToggle = document.querySelector("[data-filter-toggle]");
  if (filterToggle) {
    filterToggle.addEventListener("click", function () {
      var panel = document.querySelector("[data-filter-panel]");
      if (panel) panel.classList.toggle("is-open");
    });
  }

  /* ----------------------------------------------------- announcement hide */

  var noticeHide = document.querySelector("[data-notice-hide]");
  if (noticeHide) {
    noticeHide.addEventListener("click", function () {
      var notice = document.querySelector("[data-notice]");
      if (notice) notice.remove();
    });
  }

  /* ------------------------------------------------------------- accordions */

  document.querySelectorAll(".accordion__toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var accordion = toggle.closest(".accordion");
      var open = accordion.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      var marker = toggle.querySelector("span");
      if (marker) marker.textContent = open ? "–" : "+";
    });
  });

  /* ------------------------------------------------------------------- bag */

  function renderBag(cart) {
    var body = document.querySelector("[data-bag-body]");
    var subtotal = document.querySelector("[data-bag-subtotal]");
    var checkout = document.querySelector("[data-bag-checkout]");

    // Numeric badge over the hero — hidden when the bag is empty.
    document.querySelectorAll("[data-bag-count]").forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });

    // "Bag" in the compact bar — gains a count only once something is in it.
    document.querySelectorAll("[data-bag-label]").forEach(function (el) {
      var label = el.getAttribute("data-label") || "Bag";
      el.textContent = cart.item_count > 0 ? label + " (" + cart.item_count + ")" : label;
    });

    // Drawer heading — always shows the count, including zero.
    document.querySelectorAll("[data-bag-title]").forEach(function (el) {
      var label = el.getAttribute("data-label") || "Bag";
      el.textContent = label + " (" + cart.item_count + ")";
    });

    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0;
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="muted">Your bag is empty.</p>';
      return;
    }

    body.innerHTML =
      '<ul class="bag__lines">' +
      cart.items
        .map(function (item) {
          var image = item.image
            ? '<img src="' + item.image.replace(/(\.[^.]*)$/, "_200x$1") + '" alt="">'
            : "";
          return (
            '<li class="bag__line">' +
            '<a href="' + item.url + '">' + image + "</a>" +
            '<div class="bag__line-info">' +
            '<a href="' + item.url + '">' + item.product_title + "</a>" +
            '<span class="muted">' +
            (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title + " / " : "") +
            "Qty " + item.quantity +
            "</span>" +
            "<span>" + money(item.final_line_price) + "</span>" +
            '<button type="button" class="link muted" data-bag-remove="' + item.key + '">Remove</button>' +
            "</div>" +
            "</li>"
          );
        })
        .join("") +
      "</ul>";
  }

  function refreshBag(open) {
    return fetch(window.Shopify.routes.root + "cart.js")
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderBag(cart);
        if (open) openDrawer("bag-drawer");
        return cart;
      });
  }

  function addToCart(variantId, button) {
    var original = button ? button.textContent : null;
    if (button) button.textContent = "Adding";

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (e) { throw new Error(e.description || "Sold out"); });
        return refreshBag(true);
      })
      .catch(function (error) {
        alert(error.message);
      })
      .finally(function () {
        if (button && original !== null) button.textContent = original;
      });
  }

  document.addEventListener("click", function (event) {
    var quickAdd = event.target.closest("[data-quick-add]");
    if (quickAdd) {
      event.preventDefault();
      addToCart(quickAdd.getAttribute("data-quick-add"), quickAdd);
      return;
    }

    var remove = event.target.closest("[data-bag-remove]");
    if (remove) {
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: remove.getAttribute("data-bag-remove"), quantity: 0 }),
      }).then(function () { refreshBag(false); });
    }
  });

  if (document.querySelector("[data-bag-body]")) refreshBag(false);

  /* ------------------------------------------------------- product options */

  // Variant picking is done in the browser from the variant list Liquid
  // printed into the page, so no page reload is needed between selections.
  var form = document.querySelector("[data-product-form]");

  if (form) {
    var dataEl = document.querySelector("[data-product-variants]");
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector("[data-add-button]");
    var priceEl = document.querySelector("[data-product-price]");
    var selected = {};

    form.querySelectorAll("[data-option-index]").forEach(function (button) {
      if (button.getAttribute("aria-pressed") === "true") {
        selected[button.getAttribute("data-option-index")] = button.getAttribute("data-option-value");
      }
    });

    var sync = function () {
      var chosen = variants.find(function (variant) {
        return Object.keys(selected).every(function (index) {
          return variant.options[Number(index)] === selected[index];
        });
      });

      var complete = Object.keys(selected).length === Number(form.getAttribute("data-option-count"));

      if (!complete) {
        submit.disabled = false;
        submit.textContent = "Select A Size";
        return;
      }

      if (!chosen) {
        submit.disabled = true;
        submit.textContent = "Unavailable";
        return;
      }

      idInput.value = chosen.id;
      submit.disabled = !chosen.available;
      submit.textContent = chosen.available ? "Add To Bag" : "Sold Out";

      if (priceEl && chosen.price != null) priceEl.textContent = money(chosen.price);

      var label = document.querySelector("[data-selected-color]");
      if (label && selected["0"]) label.textContent = selected["0"];
    };

    form.addEventListener("click", function (event) {
      var button = event.target.closest("[data-option-index]");
      if (!button) return;
      event.preventDefault();

      var index = button.getAttribute("data-option-index");
      selected[index] = button.getAttribute("data-option-value");

      form.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (sibling) {
        sibling.setAttribute("aria-pressed", sibling === button ? "true" : "false");
      });

      sync();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!idInput.value) return;
      addToCart(idInput.value, submit);
    });

    sync();
  }
})();
